import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import RichTextEditor from 'react-rte';
import { Tabs, Tab } from 'material-ui/Tabs';
import {
  fetchActivity,
  saveActivity,
  setActivityForm,
  setActivity,
} from '../../store/modules/activity';
import classes from './SideBarActivities.scss';
import { Activity } from '../Activity/Activity';

import mergeStates from '../../helpers/mergeStates';
import { wysiwygOptions } from '../../helpers/wysiwygOptions';
import FormActivity from '../FormActivity/FormActivity';

const mapActionCreators = {
  fetchActivity,
  saveActivity,
  setActivity,
  setActivityForm,
};

const mapStateToProps = state => ({
  activity: state.activity.activities[state.activity.current],
  activities: state.activity.activities,
  tasks: state.task.tasks,
  staff: state.staff.staffs,
  persons: state.person.persons,
  fetching: state.activity.fetching,
  current: state.activity.current,
  login: state.login,
});

class SideBarActivities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newActivity: '',
      hideCompleted: true,
      open: false,
      editorState: RichTextEditor.createEmptyValue(),
      notes: '',
      activityError: false,
      personsRaw: null,
    };
  }

  onTextChange = value => {
    const newState = this.state;

    newState.editorState = value;
    newState.notes = value.toString('html');

    this.setState(newState);
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
  };

  deactivateAdvancedInput = () => {
    this.setState({
      open: true,
    });
  };

  activateAdvancedInput = () => {
    this.setState({
      open: true,
    });
  };

  resetActivity = () => {
    // const newState = widgetInitialState;
    // widgetInitialState.task.assignee = this.props.login.user.id;
    const newState = this.state;
    newState.title = '';
    newState.notes = '';
    newState.communication_type = 'none';
    newState.editorState = RichTextEditor.createEmptyValue();
    newState.personsRaw = null;

    this.setState({ activity: newState.activity });
  };

  saveActivity = () => {
    if (this.state.title.length) {
      // console.log('saving activity!', this.state);
      this.props.saveActivity(this.state);
      this.resetActivity();
    } else {
      this.setState({ activityError: true });
      // disable error message after 5 seconds
      setTimeout(() => {
        this.setState({ activityError: false });
      }, 5000);
    }
  };

  editActivityInModal = () => {
    // console.log('editing activity in modal!', this.state);
    this.props.setActivityForm(null, _.clone(this.state));
    this.resetActivity();
  };

  renderAdvancedInput = () => {
    if (!this.state.open) {
      return null;
    }

    return (
      <div className="row">
        <div className="col-xs-12 col-sm-12">
          <RichTextEditor
            toolbarClassName="rte-toolbar"
            editorClassName="rte-editor"
            value={this.state.editorState}
            onChange={this.onTextChange}
            toolbarConfig={wysiwygOptions}
          />
        </div>
        <div className="col-xs-12 col-sm-6">
          <a
            onClick={() => {
              this.editActivityInModal();
            }}
          >
            Alle Felder anzeigen
          </a>
        </div>
        <div className="col-xs-12 col-sm-6">
          <a
            onClick={() => {
              this.saveActivity();
            }}
          >
            speichern
          </a>
        </div>
      </div>
    );
  };

  render() {
    const props = this.props;

    const myActivities = [];
    const allActivities = [];

    const sortedActivities = _.orderBy(
      props.activities,
      ['start_time'],
      ['desc'],
    );

    _.forOwn(sortedActivities, data => {
      if (data.deleted_at === null) {
        if (data.responsible_user === props.login.staff.id) {
          myActivities.push(
            <Activity
              key={`activity_sidebar_${data.id}`}
              activity={data}
              tasks={_.pick(props.tasks, data.tasks)}
              staff={_.pick(props.staff, data.staff)}
              persons={_.pick(props.persons, data.persons)}
              displayMode="sidebar"
            />,
          );
        }

        allActivities.push(
          <Activity
            key={`activity_sidebar_${data.id}`}
            activity={data}
            tasks={_.pick(props.tasks, data.tasks)}
            staff={_.pick(props.staff, data.staff)}
            persons={_.pick(props.persons, data.persons)}
            displayMode="sidebar"
          />,
        );
      }
    });

    return (
      <Tabs
        className={classes.tabs}
        contentContainerClassName={classes.tabscontainer}
        tabItemContainerStyle={{
          backgroundColor: '#fafafa',
          height: 48,
          minHeight: 48,
        }}
      >
        <Tab
          label="Meine Aktivitäten"
          className={classes.tab}
          style={{ color: '#4a4a4a', height: 36 }}
        >
          <section className={classes.header} />
          <section className={classes.taskSection}>{myActivities}</section>
          <section className={classes.newTask}>
            <FormActivity type="embed" originalType="embed" sidebar />
          </section>
        </Tab>
        <Tab
          label="Alle Aktivitäten"
          className={classes.tab}
          style={{
            color: '#4a4a4a',
            height: 36,
          }}
        >
          <section className={classes.taskSection}>{allActivities}</section>
        </Tab>
      </Tabs>
    );
  }
}
SideBarActivities.propTypes = {
  saveActivity: PropTypes.func,
  setActivityForm: PropTypes.func,
};
export default connect(mapStateToProps, mapActionCreators)(SideBarActivities);



// WEBPACK FOOTER //
// ./src/components/SideBarActivities/SideBarActivities.js